<template>
	<drop-panel class="st-panel" appearance="dropdown">
		<select-tree-item v-for="sti in  items" :item="sti" :key="sti.id" v-model="dataValue" v-model:selection="selectedValue" :dir="dir"></select-tree-item>
	</drop-panel>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import type {SelectHierarchy, SelectHierarchyItem} from "@t/ui/SelectHierarchy.ts";
import SelectTreeItem from "@/ui/select/SelectTreeItem.vue";
import DropPanel from "@/ui/paneltree/DropPanel.vue";

const props = defineProps<{
	items: SelectHierarchyItem[],
	modelValue: string|null|undefined,
	selection: string|null|undefined,
	dir: "left" | "right"
}>();
const emit = defineEmits(['update:modelValue', 'update:selection']);

const dataValue = computed<string>({
	get():string {
		return props.modelValue;
	},
	set(v: string):void {
		emit('update:modelValue', v);
	}
});

const selectedValue = computed<string>({
	get():string {
		return props.selection;
	},
	set(v: string):void {
		emit('update:selection', v);
	}
});

</script>

<style>
.st-panel > .drop-panel-body {
	padding: 4px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
}
</style>